module.exports = __webpack_public_path__ + "img/map_pin_home3.7de52e4f.svg";